
import { DisenioPaginas } from '../../layout';
import { CreateUpdateGranja } from '../../components';




export const CrearGranjas = () => {


    const initialState = {
        nombre: '',
        metros: '',
        direccion: '',
        propietario: '',
        departamento: '',
        ciudad: '',
    };



    return (

        <DisenioPaginas titulo="Crear Granja" url={1} add={false} subtitulo="Información de la granja">
            <CreateUpdateGranja initialState={initialState} />
        </DisenioPaginas>

    )
}
